/* 🤖 this file was generated by svg-to-ts */
export const matIconFileDownloadDone: {
  name: 'file-download-done';
  data: string;
} = {
  name: 'file-download-done',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M20.13 5.41 18.72 4l-9.19 9.19-4.25-4.24-1.41 1.41 5.66 5.66zM5 18h14v2H5z"/></svg>`
};
